/*
 * @Author: lidan
 * @Date: 2020-12-15 09:59:04
 * @LastEditTime: 2020-12-15 10:01:12
 * @LastEditors: lidan
 * @Description: 送货员津贴汇总表api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\deliveryAllowanceSummary.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取送货员津贴汇总表格数据
export function queryPageTotalDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/deliveryReport/queryPageTotal`,
    method: "post",
    data
  });
}

// 导出送货员津贴汇总表
export function exportAllowanceTotalDelivery(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/deliveryReport/exportTotal`,
    method: "post",
    data
  });
}
